const moment = require("moment");

const cafe = {
    default: {
        colors: {
            primary: "#007bff",
            success: "#28a745",
            red: "#dc3545",
            purple: "purple",
        },
        cookies: {
            domain: "es6.vn",
            path: "/",
            secure: true,
            sameSite: "none",
            expires: 24 * 60 * 60 * 1000,
            isUpdate: true,
        },
    },
    format: {
        dateTime: "YYYY-MM-DD HH:mm:ss",
    },
};
const df = cafe.default;

const logPrimary = (text, obj) => {
    if (typeof (obj) === "undefined") obj = moment().format(cafe.format.dateTime);
    let color = df.colors.primary;
    let border = `border:1px solid ${color}`;
    let padding = "padding:2px 6px";
    let styles = [
        [`background-color:${color}`, "color:#fff", border, padding, "border-radius:4px 0 0 4px"],
        [border, padding, "border-radius: 0 4px 4px 0", `color:${color}`],
    ];
    if (typeof (obj) === "string") console.log(`%c${text}%c${obj}`, styles[0].join(";"), styles[1].join(";"));
    else console.log(`%c${text}`, styles[0].join(";"), obj);
};

const logSuccess = (text, obj) => {
    if (typeof (obj) === "undefined") obj = moment().format(cafe.format.dateTime);
    let color = df.colors.success;
    let border = `border:1px solid ${color}`;
    let padding = "padding:2px 6px";
    let styles = [
        [`background-color:${color}`, "color:#fff", border, padding, "border-radius:4px 0 0 4px"],
        [border, padding, "border-radius: 0 4px 4px 0", `color:${color}`],
    ];
    if (typeof (obj) === "string") console.log(`%c${text}%c${obj}`, styles[0].join(";"), styles[1].join(";"));
    else console.log(`%c${text}`, styles[0].join(";"), obj);
};

const logStart = (text01, text02, obj) => {
    if (typeof (obj) === "undefined") obj = moment().format(cafe.format.dateTime);
    let color = df.colors.primary;
    let border = `border:1px solid ${color}`;
    let padding = "padding:2px 6px";
    let styles = [
        [`background-color:${color}`, "color:#fff", border, padding, "border-radius:4px 0 0 4px"],
        [border, padding, "border-radius: 0 4px 4px 0", `color:${color}`],
    ];
    console.log(`%c${text01}%c${text02}`, styles[0].join(";"), styles[1].join(";"), obj);
};

const logEnd = (text01, text02, obj) => {
    if (typeof (obj) === "undefined") obj = moment().format(cafe.format.dateTime);
    let color = df.colors.primary;
    let border = `border:1px solid ${color}`;
    let padding = "padding:2px 6px";
    let styles = [
        [`color:${color}`, border, padding, "border-radius:4px 0 0 4px"],
        [`background-color:${color}`, "color:#fff", border, padding, "border-radius: 0 4px 4px 0"],
    ];
    console.log(`%c${text01}%c${text02}`, styles[0].join(";"), styles[1].join(";"), obj);
};

const logPurpleStart = (text01, text02, obj) => {
    if (typeof (obj) === "undefined") obj = moment().format(cafe.format.dateTime);
    let color = df.colors.purple;
    let border = `border:1px solid ${color}`;
    let padding = "padding:2px 6px";
    let styles = [
        [`background-color:${color}`, "color:#fff", border, padding, "border-radius:4px 0 0 4px"],
        [border, padding, "border-radius: 0 4px 4px 0", `color:${color}`],
    ];
    console.log(`%c${text01}%c${text02}`, styles[0].join(";"), styles[1].join(";"), obj);
};

const logPurpleEnd = (text01, text02, obj) => {
    if (typeof (obj) === "undefined") obj = moment().format(cafe.format.dateTime);
    let color = df.colors.purple;
    let border = `border:1px solid ${color}`;
    let padding = "padding:2px 6px";
    let styles = [
        [`color:${color}`, border, padding, "border-radius:4px 0 0 4px"],
        [`background-color:${color}`, "color:#fff", border, padding, "border-radius: 0 4px 4px 0"],
    ];
    console.log(`%c${text01}%c${text02}`, styles[0].join(";"), styles[1].join(";"), obj);
};

const logError = (text01, text02, obj) => {
    if (typeof (obj) === "undefined") obj = moment().format(cafe.format.dateTime);
    let color = df.colors.red;
    let border = `border:1px solid ${color}`;
    let padding = "padding:2px 6px";
    let styles = [
        [`background-color:${color}`, "color:#fff", border, padding, "border-radius:4px 0 0 4px"],
        [border, padding, "border-radius: 0 4px 4px 0", `color:${color}`],
    ];
    console.log(`%c${text01}%c${text02}`, styles[0].join(";"), styles[1].join(";"), obj);
};

const logRed = (text01, text02, obj) => {
    if (typeof (obj) === "undefined") obj = moment().format(cafe.format.dateTime);
    let color = df.colors.red;
    let border = `border:1px solid ${color}`;
    let padding = "padding:2px 6px";
    let styles = [
        [`background-color:${color}`, "color:#fff", border, padding, "border-radius:4px 0 0 4px"],
        [border, padding, "border-radius: 0 4px 4px 0", `color:${color}`],
    ];
    console.log(`%c${text01}%c${text02}`, styles[0].join(";"), styles[1].join(";"), obj);
};

const mapCategories = ({ categories, data }) => {
    let list = [];
    if (!Array.isArray(data)) return list;
    for (let cat of categories) {
        let { CategoryID, CategoryName, Search } = cat;
        list.push({
            CategoryID,
            CategoryName,
            Search,
            children: [],
        });
    }
    for (let item of data) {
        let { CategoryID } = item;
        for (let cat of list) {
            if (cat.Search.includes(CategoryID))
                cat.children.push(item);
        }
    }
    list = list.filter((cat) => cat.children.length > 0);

    return list;
};

const isImage = (fileType) => {
    fileType = fileType || "";
    let regImg = new RegExp(/image\/*/g);
    let regWebp = new RegExp(/image\/webp/g);
    let isValid = regImg.test(fileType) && !regWebp.test(fileType);

    return isValid;
};

const isError = (obj) => {
    if (typeof (obj) === "string") return obj;
    let isTypeError = Object.prototype.toString.call(obj) === "[object Error]";
    if (isTypeError) return obj.toString();
    return JSON.stringify(obj);
};

const waitPromise = (x) => {
    let p = new Promise((resolve) => {
        if (isNaN(x)) return resolve();
        setTimeout(resolve, x);
    });

    return p;
};

const downloadFile = (obj) => {
    let href = obj;
    if (typeof (obj) === "object") {
        href = obj.href;
        a.download = obj.fileName;
    };
    let a = window.document.createElement("a");
    a.href = href;
    a.target = "_blank";
    document.body.appendChild(a);
    a.click();
    window.URL.revokeObjectURL(href);
    document.body.removeChild(a);
};

const downloadBlob = ({ data, fileName = "download-data.txt" }) => {
    console.log("downloadBlob", data);
    let a = document.createElement("a");
    a.href = window.URL.createObjectURL(data);
    a.target = "_blank";
    a.download = fileName;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
};

export const copyObject = (obj) => {
    return JSON.parse(JSON.stringify(obj));
};

export const readFile = (file) => {
    let p = new Promise((resolve) => {
        let r = new FileReader();
        r.onload = (e) => {
            resolve({ src: e.target.result });
        };
        r.readAsDataURL(file);
    });

    return p;
};

export const log = {
    start: logStart,
    end: logEnd,
    primary: logPrimary,
    purple: {
        start: logPurpleStart,
        end: logPurpleEnd,
    },
    success: logSuccess,
    error: logError,
    red: logRed,
};

export const setCookie = ({
    ckName,
    ckValue,
    ckDomain = df.cookies.domain,
    ckPath = df.cookies.path,
    ckSecure = df.cookies.secure,
    ckExpires = df.cookies.expires,
    isUpdate = df.cookies.isUpdate,
}) => {
    let d = new Date();
    d.setTime(d.getTime() + ckExpires);
    let cookie = `${ckName}=${ckValue};expires=${d.toUTCString()};path=${ckPath};domain=.${ckDomain};`;
    if (ckSecure) cookie += `samesite=none;secure=${ckSecure};`;
    if (isUpdate) return document.cookie = cookie;
    let cname = `${ckName}=`;
    let cvalue = "";
    let ca = (document.cookie || "").split(";");
    for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) === " ") c = c.substring(1);
        if (c.indexOf(cname) === 0) {
            cvalue = c.substring(cname.length, c.length);
            break;
        };
    };
    if (!cvalue) document.cookie = cookie;
};

export const getCookie = (cname) => {
    let name = cname + "=";
    let ca = document.cookie.split(";");
    for (let c of ca) {
        c = c.trimStart();
        if (c.indexOf(name) === 0) return c.substring(name.length, c.length);
    };

    return "";
};

export const download = {
    file: downloadFile,
    blob: downloadBlob,
};

export const map = {
    categories: mapCategories,
};

export const is = {
    image: isImage,
    error: isError,
};

export const wait = {
    promise: waitPromise,
};


// WEBPACK FOOTER //
// src/utils/helpers/helper.html.js